function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

require("core-js/modules/es.date.to-iso-string.js");

require("core-js/modules/es.parse-int.js");

require("core-js/modules/es.regexp.constructor.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.string.match.js");

require("core-js/modules/es.string.search.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

/**
 * 性能上报函数
 */
var _require = require('./util'),
    monitorLog = _require.monitorLog;

function YjPerformance() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // 没有性能信息
  if (typeof performance === 'undefined') return false; // 单页spa应用跳转时不记录，因为不准确

  if (window.ROUTER_HREF > 1) return false; // try {
  //   const _option = Object.assign({pageid: null}, option)
  //   Object.keys(_option).forEach(key => {
  //     if (typeof _option[key] != 'number') {
  //       throw new Error('YjPerformance 页面性能监控埋点参数错误 ~~~')
  //     }
  //   })
  // }catch (err) {
  //   console.error(err)
  //   return
  // }

  var timing = performance.timing;
  var p = {};
  p.fpt = 0; // 首屏时间字段

  observerLCP(); // 计算fcp 赋值给 fpt字段

  p.pageid = option.pageid;
  p.dns = timing.domainLookupEnd - timing.domainLookupStart; //  DNS解析时间    

  p.tcp = timing.connectEnd - timing.connectStart; //  TCP链接耗时

  p.unload = timing.unloadEventEnd - timing.unloadEventStart; // 页面卸载耗时

  p.err = 0; //  统计字段异常错误数

  p.request = 0; //  request请求耗时 

  p.eventTime = new Date().toISOString(); //  当前时间

  p.application = getAppLication(); //  h5, ios, android, wechat

  p.appIdForH5 = getAppIdForH5(); //  ''

  p.cache = getUseCacheStatus(); //  1: 使用了缓存， 0: 没有使用缓存

  var loadTime = getCssJsLoadTime();
  p.jsTotalTime = parseInt(loadTime.jsTotalTime); //  加载js总耗时

  p.cssTotalTime = parseInt(loadTime.cssTotalTime); //  加载css总耗时

  var appCont = getQueryString('appCont') || 0;
  p.env = window && window.location.host === 't-do-dev.yunjiglobal.com' ? 'test' : 'master'; // 区分环境：test | 测试环境; master | 生产环境

  if (appCont == 0) {
    p.userId = '';
    p.mobileSystem = getWechatMobileSystem();
    p.mobile = '';
  } else {
    var ua = appUa();
    p.userId = ua.user_id ? ua.user_id : '';
    p.consumerId = ua.consumerId ? ua.consumerId : '';
    p.mobileSystem = ua.mobile_system ? ua.mobile_system : ''; // 手机系统

    p.mobile = ua.mobile ? ua.mobile : ''; // 手机型号
  }

  if (timing.loadEventEnd === 0 || timing.domInteractive === 0 || timing.responseEnd === 0) {
    var timer = null;
    timer = setInterval(function () {
      if (timing.loadEventEnd > 0 && timing.domInteractive > 0) {
        clearInterval(timer);
        reportStart();
      }
    }, 500);
  } else {
    reportStart();
  }

  function reportStart() {
    appReport(); // 性能数据传给客户端进行上报

    if (p && p.pageid) {
      // 旧的性能数据采集方式，必须传pageid
      setParameter();
      imageReq();
    }
  }

  function appReport() {
    // 性能原始数据采集
    var h5Performance = {
      "h5Url": window.location.origin + window.location.pathname,
      //当前页面链接
      "h5NavigationStartTime": timing.navigationStart,
      "h5RedirectStartTime": timing.redirectStart,
      "h5RedirectEndTime": timing.redirectEnd,
      "h5FetchStartTime": timing.fetchStart,
      "h5DomainLookUpStartTime": timing.domainLookupStart,
      "h5DomainLookUpEndTime": timing.domainLookupEnd,
      "h5ConnectStartTime": timing.connectStart,
      "h5SecureConnectStartTime": timing.secureConnectionStart,
      "h5ConnectEndTime": timing.connectEnd,
      "h5RequestStartTime": timing.requestStart,
      "h5ResponseStartTime": timing.responseStart,
      "h5ResponseEndTime": timing.responseEnd,
      "h5DomLoading": timing.domLoading,
      "h5DomInterActive": timing.domInteractive,
      "h5DomContentLoadedEventStart": timing.domContentLoadedEventStart,
      "h5DomContentLoadedEventEnd": timing.domContentLoadedEventEnd,
      "h5DomComplete": timing.domComplete,
      "h5LoadEventStart": timing.loadEventStart,
      "h5LoadEventEnd": timing.loadEventEnd
    }; // app支持有则调用，无则跳过

    if (typeof yjapp != "undefined" && typeof yjapp['jsCallNativeToReportPerformance'] == 'function') {
      // 与安卓app通讯方式
      yjapp['jsCallNativeToReportPerformance'](JSON.stringify(h5Performance));
    } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers['jsCallNativeToReportPerformance']) {
      // 与iOS app通讯方式
      window.webkit.messageHandlers['jsCallNativeToReportPerformance'].postMessage(JSON.stringify(h5Performance));
    }

    monitorLog('h5_performance_log', JSON.stringify(h5Performance));
  } // 监听dom 获取lcp时间，赋值给


  function observerLCP() {
    try {
      new PerformanceObserver(function (entryList) {
        var _iterator = _createForOfIteratorHelper(entryList.getEntries()),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var entry = _step.value;
            p.fpt = entry.startTime; // console.log('LCP candidate:', entry.startTime, entry);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }).observe({
        type: 'largest-contentful-paint',
        buffered: true
      });
    } catch (err) {
      console.error(err);
    }
  }

  function setParameter() {
    p.load = timing.loadEventEnd - timing.fetchStart;
    p.whitescreen = timing.domInteractive - timing.fetchStart; //  白屏时间 

    p.request = timing.responseEnd - timing.responseStart;
    p.ttfb = timing.responseStart - timing.navigationStart; // 获取首请求首字节耗时
  } // 处理异常数据


  function setTermination(key, time) {
    if (p[key] > time) {
      p.err = p.err + 1;
      p[key] = time;
    }
  }

  function getQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);

    if (r != null) {
      return unescape(r[2]);
    }

    return null;
  }

  function imageReq() {
    var delay1000 = ['dns', 'tcp'];
    var delay10000 = ['request', 'whitescreen', 'ttfb', 'unload', 'load'];
    Object.keys(p).forEach(function (key) {
      if (delay1000.indexOf(key) > -1) setTermination(key, 1000);
      if (delay10000.indexOf(key) > -1) setTermination(key, 10000);
    });
    var u = '';

    if (process.env.NODE_ENV === 'development') {
      u = "http://static.yunjiglobal.com/event/collect.json";
    } else {
      u = "http://current.yunjiglobal.com/event/collect.json";
    }

    new Image().src = u + '?data=' + JSON.stringify(p);
  }
}

function getCssJsLoadTime() {
  try {
    var per = performance.getEntriesByType("resource");
    var cssTotalTime = 0;
    var jsTotalTime = 0;
    per.forEach(function (key) {
      if (key.initiatorType === 'link' && key.name.indexOf('.css') > -1) {
        cssTotalTime += key.duration;
      }

      if ((key.initiatorType === 'link' || key.initiatorType === 'script') && key.name.indexOf('.js')) {
        jsTotalTime += key.duration;
      }
    });
    return {
      cssTotalTime: cssTotalTime,
      jsTotalTime: jsTotalTime
    };
  } catch (err) {
    return {
      cssTotalTime: 0,
      jsTotalTime: 0
    };
  }
}
/**
 * 获取资源缓存加载情况
 */


function getUseCacheStatus() {
  try {
    var p = performance.getEntriesByType("resource");
    var useCache = 0;
    var scriptNum = 0;
    p.forEach(function (key) {
      if (scriptNum < 2) scriptNum++;

      if (key.initiatorType === 'script') {
        if (key.duration > 8) {
          throw new Error();
        } else if (scriptNum >= 2 && key.duration < 10) {
          useCache = 1;
        }
      }
    });
  } catch (err) {
    useCache = 0;
  }

  return useCache;
}
/**
 * 获取appUa
 */


function appUa() {
  var _appUA = navigator.userAgent; //app的UserAgent信息

  if (_appUA && _appUA.indexOf('{"appVersion') != -1) {
    return JSON.parse(_appUA.substring(_appUA.indexOf('{')));
  }

  return {};
}
/**
 * 获取appClient
 */


function getAppLication() {
  if (appUa().appClient) return appUa().appClient;
  if (isWeiXin()) return 'wechat';
  return 'h5';
} // 获取微信端手机系统


function getWechatMobileSystem() {
  var ua = navigator.userAgent;
  var mobileSystem = null;

  if (isWeiXin()) {
    if (mobileSystem = ua.match(/Android\s[^;]+/)) {
      return mobileSystem[0];
    }

    if (/\(i[^;]+;( U;)? CPU .+Mac OS X/.test(ua)) {
      if (mobileSystem = ua.match(/OS ([\d_]+)/)) {
        return mobileSystem[1] ? "iOS ".concat(mobileSystem[1].replace(/_/g, '.')) : 'iOS';
      }

      return 'iOS';
    }
  }

  return '';
}
/**
 * 获取getAppIdForH5
 */


function getAppIdForH5() {
  if (appUa().appIdForH5) return appUa().appIdForH5;
  return '';
}
/**
 * 是不是微信中
 */


function isWeiXin() {
  var ua = window.navigator.userAgent.toLowerCase();

  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  } else {
    return false;
  }
}

module.exports = YjPerformance;